import React, { Component, Fragment } from 'react'
import { TableRow, TableCell, MenuItem, IconButton } from '@material-ui/core'
import { Delete } from '@material-ui/icons'

// utils
import { onChangeEditHOF } from '../../../utils/common'
import { hasAccess } from '../../../utils/api'

import {
  EditableSelect,
  EditableCheckbox,
  EditableReactSelect,
  EditableReactSelectAsync,
} from '../../common/EditableComponents'
import EditActionIconComponent from '../../common/EditActionIconComponent'
import { convertArrayToOptions, getIntersection } from '../../../utils/array'
import _ from 'lodash'
import { connect } from 'react-redux'

class WeedMapMenuListItem extends Component {
  constructor(props) {
    super(props)
    this.timeout = null
    this.state = {
      selectedBrandName: '',
      selectedWmTagGroups: [],
      selectedDiscoveryTags: [],
    }
  }

  componentDidMount() {
    this.setProductTagGroups()
  }

  setProductTagGroups = () => {
    const { data, weedmapTags } = this.props
    const { productTagGroups = [] } = data
    let selectedWmTagGroups = [],
      selectedDiscoveryTags = []

    let discoveryTags = []

    const uniqueTagGroups = _.uniqBy(productTagGroups, 'wmTagGroup')
    const uniqueDiscoveryTags = _.uniqBy(productTagGroups, 'wmDiscoveryTag')

    const tagGroupIntersection = getIntersection(
      weedmapTags,
      uniqueTagGroups.map((tagGroup) => ({ ...tagGroup, tagGroupId: tagGroup.wmTagGroup })),
      'tagGroupId',
    )

    tagGroupIntersection.forEach((tagGroup) => {
      discoveryTags = [
        ...discoveryTags,
        ...(tagGroup.discoveryTags.map((tag) => ({
          ...tag,
          wmTagGroup: tagGroup.tagGroupId,
          wmTagGroupName: tagGroup.tagGroupName,
        })) || []),
      ]
    })

    const discoveryTagsIntersection = getIntersection(
      discoveryTags,
      uniqueDiscoveryTags.map((discoveryTag) => ({
        ...discoveryTag,
        tagId: discoveryTag.wmDiscoveryTag,
      })),
      'tagId',
    )

    selectedWmTagGroups = convertArrayToOptions(tagGroupIntersection, 'tagGroupName', 'tagGroupId')
    selectedDiscoveryTags = convertArrayToOptions(discoveryTagsIntersection, 'tagName', 'tagId')

    this.setState({
      selectedWmTagGroups,
      selectedDiscoveryTags,
    })
  }

  onChange = onChangeEditHOF(this.props.onChange)

  componentWillReceiveProps(nextProps) {
    if (nextProps.weedmapCategory != this.props.weedmapCategory) {
      // eslint-disable-line
      this.onChangeWeedmapTags(0)({ target: { value: nextProps.weedmapCategory } })
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.lastUpdateTime != this.props.lastUpdateTime) {
      // eslint-disable-line
      this.setProductTagGroups()
    }
  }

  onSave = () => {
    const { productTagGroups = [], thirdPartyBrandId, thirdPartyProduct } = this.props.data

    for (let i = 0; i < productTagGroups.length; ++i) {
      const tagGroup = productTagGroups[i]
      if (!tagGroup.wmDiscoveryTag) {
        this.props.showError(`Please select Discovery Tag for ${tagGroup.wmTagGroupName}`)
        return
      }
    }

    if (thirdPartyBrandId != 'CUSTOM' && !(thirdPartyProduct && thirdPartyProduct.id)) {
      // eslint-disable-line
      this.props.showError(`Weedmap product is not available for the selected brand`)
      return
    }

    this.props.onSave((response) => this.props.disableEdit())
  }

  onCancel = () => {
    this.props.onCancel()
  }

  enableEdit = () => {
    const { data } = this.props

    if (this.props.weedmapCategory) {
      this.props.getThirdPartyBrands(data.thirdPartyBrandName)
      this.props.getWeedmapProducts(
        data.thirdPartyProduct && data.thirdPartyProduct.id,
        data.thirdPartyBrandId,
      )
      this.props.enableEdit()
    } else {
      this.props.showError('Please select weedmap category before proceeding')
    }
  }

  onChangeWeedmapTags = (index) => (event) => {
    const { value = '' } = event.target
    const { wmTags = [] } = this.props.data || {}
    const updatedWmTags = [...wmTags]
    updatedWmTags[index] = value
    for (let i = index + 1; i < wmTags.length; ++i) {
      updatedWmTags[i] = ''
    }
    this.props.onChange('wmTags', updatedWmTags)
  }

  onChangeBrand = (value) => {
    const brand = (value && value.value) || ''
    //const sourceBrandId = value && value.sourceBrandId
    const { wmTags = [] } = this.props.data

    const updatedWmTags = [wmTags[0] || '']

    this.props.onChange('thirdPartyBrandId', brand)
    this.props.onChange('wmTags', updatedWmTags)
    this.props.onChange('thirdPartyProduct', null)
    this.setState({
      selectedDiscoveryTags: [],
      selectedWmTagGroups: [],
    })
    if (brand && brand != 'CUSTOM') {
      // eslint-disable-line
      this.props.getWeedmapProducts('', brand)
    }
  }

  onRowCheck = (event) => {
    const { data } = this.props
    this.props.onRowCheck(data, event)
  }

  onChangeProduct = (value) => {
    this.props.onChange('thirdPartyProduct', value)
  }

  loadThirdPartyBrands = (term, callback) => {
    this.props.onChange('thirdPartyBrandId', '')
    if (this.timeout) {
      clearTimeout(this.timeout)
    }

    if (term.length === 0) {
      callback(null, { options: [{ label: 'Custom', value: 'CUSTOM' }] })
      return
    }

    this.timeout = setTimeout(() => {
      this.props.getThirdPartyBrands(term).then((res) => {
        let options =
          (res &&
            res.values &&
            res.values.map((brand) => ({
              ...brand,
              label: brand.name,
              value: brand.sourceBrandId,
            }))) ||
          []
        options = [{ label: 'Custom', value: 'CUSTOM' }, ...options]
        callback(null, { options })
      })
    }, 500)
  }

  onChangeTagGroup = (key) => (values) => {
    let { selectedWmTagGroups, selectedDiscoveryTags = [] } = this.state
    let productTagGroups = []
    this.setState({
      [key]: values || [],
    })
    if (key === 'selectedWmTagGroups') {
      let difference = selectedWmTagGroups.find((x) => !values.includes(x))
      if (difference) {
        selectedDiscoveryTags = selectedDiscoveryTags.filter(
          (discoveryTag) => discoveryTag.data.wmTagGroup !== difference.value,
        )
        this.setState({
          selectedDiscoveryTags,
        })
      }
      productTagGroups = this.getProductTagGroups(values, selectedDiscoveryTags)
    } else {
      productTagGroups = this.getProductTagGroups(selectedWmTagGroups, values)
    }
    this.props.onChange('productTagGroups', productTagGroups)
  }

  getProductTagGroups = (tagGroups, discoveryTags) => {
    let productTagGroups = []
    tagGroups.forEach((tagGroup) => {
      const filteredDiscoveryTags = discoveryTags
        .filter((discoveryTag) => discoveryTag.data.wmTagGroup === tagGroup.value)
        .map((val) => ({
          wmTagGroup: val.data.wmTagGroup,
          wmTagGroupName: val.data.wmTagGroupName,
          wmDiscoveryTag: val.value,
          wmDiscoveryTagName: val.label,
        }))
      productTagGroups = [
        ...productTagGroups,
        ...(filteredDiscoveryTags.length
          ? filteredDiscoveryTags
          : [{ wmTagGroup: tagGroup.value, wmTagGroupName: tagGroup.label }]),
      ]
    })
    return productTagGroups
  }

  onDelete = () => {
    const { data } = this.props
    this.props.onDelete(data.productId)
  }

  render() {
    const {
      data,
      editMode,
      defaultTagMapping = {},
      brandsList = [],
      weedmapTags = [],
      product = {},
      thirdPartyProducts = [],
      thirdPartyBrands = [],
      selectedProductsMap = {},
    } = this.props

    const { selectedWmTagGroups = [], selectedDiscoveryTags = [] } = this.state

    const { wmTags = [] } = data || {}

    let discoveryTags = []

    selectedWmTagGroups.forEach((tagGroup) => {
      discoveryTags = [
        ...discoveryTags,
        ...(tagGroup.data.discoveryTags.map((tag) => ({
          ...tag,
          wmTagGroup: tagGroup.data.tagGroupId,
          wmTagGroupName: tagGroup.data.tagGroupName,
        })) || []),
      ]
    })

    const secondLevelCategories =
      (defaultTagMapping['SECOND_LEVEL'] &&
        defaultTagMapping['SECOND_LEVEL'][
          (wmTags[0] && _.startCase(_.capitalize(wmTags[0]))) || ''
        ]) ||
      []
    const thirdLevelCategories =
      (defaultTagMapping['THIRD_LEVEL'] &&
        defaultTagMapping['THIRD_LEVEL'][
          (wmTags[1] && _.startCase(_.capitalize(wmTags[1]))) || ''
        ]) ||
      []

    let selectedThirdPartyBrand = thirdPartyBrands.find(
      (brand) => brand.sourceBrandId === data.thirdPartyBrandId,
    )

    if (data.thirdPartyBrandId === 'CUSTOM') {
      selectedThirdPartyBrand = { name: 'Custom', value: 'CUSTOM' }
    }

    //console.log(data, secondLevelCategories, "secondLevelCategories", thirdLevelCategories, wmTags)

    return (
      <TableRow>
        <TableCell className="first-checkbox-column">
          {!data.thirdPartyProduct ? (
            <EditableCheckbox
              checked={!!selectedProductsMap[data.productId]}
              valueToRender={''}
              editMode={true}
              onChange={this.onRowCheck}
              className="table-cus-checkbox"
            />
          ) : null}
        </TableCell>
        <TableCell className="cell-wrap-word">{product.name}</TableCell>
        <TableCell className="cell-wrap-word">
          <EditableSelect
            value={data.weedmapCategory}
            onChange={this.onChange('weedmapCategory')}
            valueToRender={product.brandName || ''}
            editMode={false}
            MenuProps={{ className: 'no-backdrop-select ' }}
          >
            {brandsList.map((item, index) => {
              return (
                <MenuItem key={index} value={item.id}>
                  {item.name}
                </MenuItem>
              )
            })}
          </EditableSelect>
        </TableCell>
        <TableCell className="cell-wrap-word" style={{ minWidth: 180 }}>
          <EditableReactSelectAsync
            options={[
              { label: 'Custom', value: 'CUSTOM' },
              ...((thirdPartyBrands &&
                thirdPartyBrands.map((brand) => ({
                  ...brand,
                  label: brand.name,
                  value: brand.sourceBrandId,
                }))) ||
                []),
            ]}
            value={
              selectedThirdPartyBrand
                ? {
                    label: selectedThirdPartyBrand.name || '',
                    value: selectedThirdPartyBrand.sourceBrandId || '',
                  }
                : null
            }
            onChange={this.onChangeBrand}
            valueToRender={
              (
                <Fragment>
                  {data.thirdPartyBrandName}
                  <br />
                </Fragment>
              ) || ''
            }
            editMode={editMode}
            MenuProps={{ className: 'no-backdrop-select' }}
            autoload={false}
            loadOptions={this.loadThirdPartyBrands}
            onBlurResetsInput={false}
            cache={false}
            placeholder="Select Brand..."
          ></EditableReactSelectAsync>
          <EditableReactSelect
            value={{
              ...(data.thirdPartyProduct || {}),
              label: (data.thirdPartyProduct && data.thirdPartyProduct.name) || '',
              value: (data.thirdPartyProduct && data.thirdPartyProduct.id) || '',
            }}
            options={thirdPartyProducts.map((product) => ({
              ...product,
              label: product.name,
              value: product.id,
            }))}
            onChange={this.onChangeProduct}
            valueToRender={
              data.thirdPartyProductName || (!data.thirdPartyProduct && 'Custom') || ''
            }
            editMode={editMode}
            MenuProps={{ className: 'no-backdrop-select' }}
            disabled={selectedThirdPartyBrand && selectedThirdPartyBrand.value === 'CUSTOM'}
            className="margin-top-xs"
          ></EditableReactSelect>
        </TableCell>
        <TableCell className="cell-wrap-word multi-select-min-width">
          {}
          {weedmapTags &&
          weedmapTags.length > 0 &&
          selectedThirdPartyBrand &&
          selectedThirdPartyBrand.value === 'CUSTOM' ? (
            <EditableReactSelect
              value={selectedWmTagGroups}
              onChange={this.onChangeTagGroup('selectedWmTagGroups')}
              valueToRender={
                (selectedWmTagGroups &&
                  selectedWmTagGroups.map((tagGroup) => tagGroup.data.tagGroupName).join(', ')) ||
                ''
              }
              editMode={editMode}
              MenuProps={{ className: 'no-backdrop-select height-multi-select' }}
              multi={true}
              className="height-multi-select"
              options={convertArrayToOptions(weedmapTags, 'tagGroupName', 'tagGroupId')}
              /* disabled={data.thirdPartyBrandId !== "CUSTOM"} */
            />
          ) : !data.thirdPartyProduct ? (
            <span>
              {(selectedWmTagGroups &&
                selectedWmTagGroups.map((tagGroup) => tagGroup.data.tagGroupName).join(', ')) ||
                ''}
            </span>
          ) : null}
        </TableCell>
        <TableCell className="cell-wrap-word multi-select-min-width">
          {discoveryTags &&
          discoveryTags.length > 0 &&
          selectedThirdPartyBrand &&
          selectedThirdPartyBrand.value === 'CUSTOM' ? (
            <EditableReactSelect
              value={selectedDiscoveryTags}
              onChange={this.onChangeTagGroup('selectedDiscoveryTags')}
              valueToRender={
                (selectedDiscoveryTags &&
                  selectedDiscoveryTags
                    .map((discoveryTag) => discoveryTag.data.tagName)
                    .join(', ')) ||
                ''
              }
              editMode={editMode}
              MenuProps={{ className: 'no-backdrop-select height-multi-select' }}
              multi={true}
              className="height-multi-select"
              options={convertArrayToOptions(discoveryTags, 'tagName', 'tagId')}
              /* disabled={data.thirdPartyBrandId !== "CUSTOM"} */
            />
          ) : !data.thirdPartyProduct ? (
            <span>
              {(selectedDiscoveryTags &&
                selectedDiscoveryTags
                  .map((discoveryTag) => discoveryTag.data.tagName)
                  .join(', ')) ||
                ''}
            </span>
          ) : null}
        </TableCell>
        <TableCell>
          {secondLevelCategories &&
          secondLevelCategories.length > 0 &&
          selectedThirdPartyBrand &&
          selectedThirdPartyBrand.value === 'CUSTOM' ? (
            <EditableSelect
              value={data.wmTags[1] || ''}
              onChange={this.onChangeWeedmapTags(1)}
              valueToRender={data.wmTags[1] || ''}
              editMode={editMode}
              MenuProps={{ className: 'no-backdrop-select' }}
            >
              {secondLevelCategories.map((item, index) => {
                return (
                  <MenuItem key={index} value={item.name}>
                    {item.name}
                  </MenuItem>
                )
              })}
            </EditableSelect>
          ) : !data.thirdPartyProduct ? (
            <span>{data.wmTags[1] || ''}</span>
          ) : null}
        </TableCell>
        <TableCell>
          {thirdLevelCategories.length &&
          selectedThirdPartyBrand &&
          selectedThirdPartyBrand.value === 'CUSTOM' ? (
            <EditableSelect
              value={data.wmTags[2] || ''}
              onChange={this.onChangeWeedmapTags(2)}
              valueToRender={data.wmTags[2] || ''}
              editMode={editMode}
              MenuProps={{ className: 'no-backdrop-select' }}
            >
              {thirdLevelCategories.map((item, index) => {
                return (
                  <MenuItem key={index} value={item.name}>
                    {item.name}
                  </MenuItem>
                )
              })}
            </EditableSelect>
          ) : !data.thirdPartyProduct ? (
            <span>{data.wmTags[2] || ''}</span>
          ) : null}
        </TableCell>
        <TableCell className="cell-wrap-word">
          {!editMode ? (
            <div className="edit-actions pull-right">
              <IconButton className="danger-button" onClick={this.onDelete}>
                <Delete />
              </IconButton>
            </div>
          ) : null}
          {hasAccess() ? (
            <div className="pull-right">
              <EditActionIconComponent
                onSave={this.onSave}
                onCancel={this.onCancel}
                onEdit={this.enableEdit}
                editMode={editMode}
                className="edit-actions"
              />
            </div>
          ) : null}
        </TableCell>
      </TableRow>
    )
  }
}

function mapStateToProps(state) {
  return {
    defaultTagMapping:
      (state.integrationReducer &&
        state.integrationReducer.weedmapAccount &&
        state.integrationReducer.weedmapAccount.defaultTagMapping) ||
      {},
  }
}

export default connect(mapStateToProps)(WeedMapMenuListItem)



// WEBPACK FOOTER //
// ./src/components/WeedmapInfo/WeedMapMenuList/WeedMapMenuListItemV2.js